import * as React from 'react';
import $i18n from 'panda-i18n';
import { CnButton } from '@/components/cn-button';
import locale from '@/locale';
$i18n.init({ locale, componentName: 'CnSubmit' });
export const CnSubmit = ({ onSubmit, onSubmitFailed, onSubmitSuccess, form, ...props }) => {
    return (React.createElement(CnButton, { type: "primary", ...props, loading: props.loading !== undefined ? props.loading : form.submitting, onClick: (e) => {
            if (props.onClick) {
                if (props.onClick(e) === false)
                    return;
            }
            if (onSubmit) {
                form.submit(onSubmit).then(onSubmitSuccess).catch(onSubmitFailed);
            }
        } }, props.children ||
        $i18n.get({
            id: '31255239613091840.CNTM',
            dm: '提交',
            ns: 'CnSubmit',
        })));
};
